<template>
  <v-card-actions>
    <v-card-title>CLIENT</v-card-title>
    <div v-if="getProjectClient.length === 0">
      <v-btn fab small color="primary" @click="addClient = true"
        ><v-icon>mdi-plus</v-icon></v-btn
      >
      <project-client-add
        :add-client="addClient"
        :project-client-list="clientList"
        @update-add-client-modal="updateAddClientModal"
      ></project-client-add>
    </div>
    <div v-else>
      <v-card-actions>
        <v-btn fab small color="primary" @click="editClient = true"
          ><v-icon>mdi-pencil</v-icon></v-btn
        >
        <project-client-edit
          :edit-client="editClient"
          :project-client-list="clientList"
          @update-edit-client-modal="updateEditClientModal"
        ></project-client-edit>
        <v-card-title class="text_box">{{
          getProjectClient[0].client_name
        }}</v-card-title>
      </v-card-actions>
    </div>
  </v-card-actions>
</template>
<script>
import ProjectClientEdit from "@/components/Projects/ProjectInnerCardsComp/ProjectClientEdit";
import ProjectClientAdd from "@/components/Projects/ProjectInnerCardsComp/ProjectClientAdd";
import {mapGetters} from "vuex";
export default {
  name: "ProjectClient",
  components: {
    "project-client-edit": ProjectClientEdit,
    "project-client-add": ProjectClientAdd,
  },
  props: ["clientList"],
  data() {
    return {
      editClient: false,
      addClient: false,
    };
  },
  computed: {
    ...mapGetters(["getProjectClient"]),
  },
  methods: {
    updateAddClientModal(value) {
      this.addClient = value;
    },
    updateEditClientModal(value) {
      this.editClient = value;
    },
  },
};
</script>
<style scoped>
.text_box {
  background-color: whitesmoke;
  padding: 10px;
  text-align: justify;
  border: 3px solid;
  border-radius: 5px;
}
</style>
